module.exports = __webpack_public_path__ + "static/media/addFavoritesMobileIcon.7dcb3dc8.svg";